"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compoundFromInchiKey = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const Compound_1 = require("../Compound");
const handleError_1 = require("./handleError");
async function compoundFromInchiKey(inchiKey, options = {}) {
    const { cache } = options;
    let compounds;
    if (cache?.(inchiKey)) {
        compounds = cache(inchiKey);
    }
    else {
        const encodedInchiKey = encodeURIComponent(inchiKey);
        const moleculeResponse = await (0, cross_fetch_1.default)(`https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/inchikey/${encodedInchiKey}/json`);
        compounds = (await moleculeResponse.json()).PC_Compounds;
        if (cache) {
            cache(inchiKey, compounds);
        }
    }
    (0, handleError_1.checkCompundsResult)(compounds);
    return new Compound_1.Compound(compounds[0], { cache });
}
exports.compoundFromInchiKey = compoundFromInchiKey;
//# sourceMappingURL=compoundFromInchiKey.js.map